import { render, staticRenderFns } from "./SettingsRoleMappingNewView.vue?vue&type=template&id=1f1360b8&scoped=true&"
import script from "./SettingsRoleMappingNewView.vue?vue&type=script&lang=js&"
export * from "./SettingsRoleMappingNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1360b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f1360b8')) {
      api.createRecord('1f1360b8', component.options)
    } else {
      api.reload('1f1360b8', component.options)
    }
    module.hot.accept("./SettingsRoleMappingNewView.vue?vue&type=template&id=1f1360b8&scoped=true&", function () {
      api.rerender('1f1360b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/role/mapping/SettingsRoleMappingNewView.vue"
export default component.exports